module.exports = __webpack_public_path__ + "static/media/_baked_ranger-upd.ea67c820.usdz";